import { createSelector } from 'reselect'

import { localize } from 'helpers/translator'

const quiz_add_question_validation_selector = createSelector(
	[ state => state.quiz ],
	quizState => {
		const valid = (quizState.questions.filter(question => question.status !== 'deleting').length) < 50
		return {
			valid,
			message: valid?null:localize('quiz_questions_limit'),
		}
	}
)

export default quiz_add_question_validation_selector
